// extracted by mini-css-extract-plugin
export default {"box":"ResponseOverTime_box__QAn8q","info":"ResponseOverTime_info__-A4Pw","header":"ResponseOverTime_header__v5IoZ"};